import { useEffect, useState } from "react";
import { getCalApi } from "@calcom/embed-react";
import { FileText, Download, Loader2, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

/* BOOK A DEMO, the real Cal.com booking (as a popup) and deck download from the live homepage.
   Same endpoint (/marketing/deck-lead) and the same Cal.com event. */

export const CAL_LINK = "mdawson40/30min";
export const CAL_NS = "30min";

export function useCalTheme() {
  useEffect(() => {
    (async () => {
      try {
        const cal = await getCalApi({ namespace: CAL_NS });
        cal("ui", { hideEventTypeDetails: false, layout: "month_view", cssVarsPerTheme: { light: { "cal-brand": "#d32f2f" }, dark: { "cal-brand": "#d32f2f" } } });
      } catch (e) {}
    })();
  }, []);
}

function DeckGate() {
  const [form, setForm] = useState({ name: "", email: "", company: "" });
  const [sending, setSending] = useState(false);
  const getDeck = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) { toast.error("Please add your name and email."); return; }
    setSending(true);
    try {
      const res = await api.post("/marketing/deck-lead", form, { responseType: "blob" });
      const fname = res.headers?.["x-deck-filename"] || "Ask Redline Enterprise Deck.pdf";
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a"); a.href = url; a.download = fname; document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success("Here's your deck, thanks for your interest!");
      setForm({ name: "", email: "", company: "" });
    } catch (err) {
      toast.error(err?.response?.status === 429 ? "You've already grabbed it, check your downloads." : "Something went wrong. Please try again.");
    } finally { setSending(false); }
  };
  return (
    <form onSubmit={getDeck} className="rm-deck" data-testid="concept-deck-gate">
      <p className="rm-small-label"><FileText size={11} /> THE DECK · PDF</p>
      <h3>Share it with your leadership.</h3>
      <p>The same walkthrough as a PDF, keep it, or hand it to the partners and operators who weigh in. Tell us where to send it.</p>
      <input data-testid="concept-deck-name" value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} placeholder="Your name" autoComplete="name" maxLength={200} />
      <input data-testid="concept-deck-email" value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} type="email" placeholder="Work email" autoComplete="email" maxLength={200} />
      <input data-testid="concept-deck-company" value={form.company} onChange={(e) => setForm((f) => ({ ...f, company: e.target.value }))} placeholder="Management company (optional)" autoComplete="organization" maxLength={200} />
      <button type="submit" disabled={sending} data-testid="concept-deck-submit">{sending ? <Loader2 size={15} className="animate-spin" /> : <Download size={15} />}{sending ? "Preparing…" : "Download the deck"}</button>
      <small>We'll only use this to follow up about Ask Redline. No spam.</small>
    </form>
  );
}

export function ContactSection() {
  useCalTheme();
  return (
    <section id="contact" className="rm-contact rm-section" data-testid="concept-contact-section" aria-labelledby="concept-contact-heading">
      <div className="rm-container">
        <div className="rm-section-heading">
          <div>
            <p className="rm-kicker">LET'S TALK</p>
            <h2 id="concept-contact-heading">Book a demo for your company.</h2>
          </div>
          <p>A 30-minute walk-through built around your portfolio, the communities you run, the systems you keep, the work you want Redline to take on.</p>
        </div>
        <div className="rm-contact-grid">
          <div className="rm-contact-book" data-testid="concept-contact-book">
            <h3>Pick a time that works.</h3>
            <p>We'll tailor it to your portfolio and answer anything on scope, setup and rollout, no slides unless you want them.</p>
            <button type="button" className="rm-button" data-cal-namespace={CAL_NS} data-cal-link={CAL_LINK} data-cal-config='{"layout":"month_view"}' data-testid="concept-cal-book">Book a demo<ArrowUpRight size={16} /></button>
            <p className="rm-fine-print">Prefer email? <a href="mailto:mike@askredline.com">mike@askredline.com</a>, we reply within one business day.</p>
          </div>
          <div className="rm-contact-side">
            <DeckGate />
          </div>
        </div>
      </div>
    </section>
  );
}
